export default "__VITE_ASSET__DQB9qS4a__"